import { Hubble, HubbleProvider } from '@seek/hubble';
import { useMelwaysInfo } from '@seek/melways-react';

import type { Config } from 'src/types/types';

interface Props {
  children: React.ReactNode;
  appConfig: Config;
}

export const HubbleClientProvider = ({ children, appConfig }: Props) => {
  const { appName, appVersion, country, environment, userId } = appConfig;

  const { brand } = useMelwaysInfo();
  const hubble = new Hubble({
    experience: 'candidate',
    appName,
    appVersion,
    loginId: userId,
    country,
    brand,
    isProduction: environment === 'production',
  });
  return <HubbleProvider hubble={hubble}>{children}</HubbleProvider>;
};
